module.exports = __webpack_public_path__ + "img/Phone_08.c97a3a8c.jpg";